module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pl10 mt20",
    staticStyle: {
      "word-break": "break-all"
    }
  }, [(_vm.control.loginType == 1) ? _c('div', {
    staticClass: "pr10 mb10",
    attrs: {
      "align": "right"
    }
  }, [(_vm.records.length > 0) ? _c('el-table', {
    attrs: {
      "data": _vm.records,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "供应商编号",
      "min-width": "200",
      "align": "center",
      "prop": "supplierCode"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "supplierName",
      "label": "供应商名称",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "当前状态",
      "min-width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.supplierStatusName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "修改原因",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "auditRemark",
      "label": "审核备注",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.editBasicInfoData(scope.row.id)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status == 1 || scope.row.status == 4 ? '编辑' : '查看'))]), _vm._v(" "), (scope.row.status == 1 || scope.row.status == 4) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.deleteRecord(scope.row.id, scope.row.status)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status == 1 ? '删除' : '取消'))]) : _vm._e()]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), (_vm.records.length == 0) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editBasicInfoData(0)
      }
    }
  }, [_vm._v("修改供应商信息")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("基础信息")]), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "mb20"
  }, [_c('el-form', {
    ref: "basicForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.basicForm,
      "label-width": "207px"
    }
  }, [_c('el-row', {
    staticClass: "mt20"
  }, [_c('el-col', {
    attrs: {
      "span": 2,
      "offset": 2
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('span', {
    staticClass: "form_color"
  }, [_vm._v("供应商编号：")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_vm._v("\n                        " + _vm._s(_vm.basicForm.suppliersCode) + "\n                    ")])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "mt20"
  }, [_c('el-col', {
    attrs: {
      "span": 2,
      "offset": 2
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('span', {
    staticClass: "form_color"
  }, [_vm._v("供应商名称：")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_vm._v("\n                        " + _vm._s(_vm.basicForm.suppliersName) + "\n                    ")])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "mt20"
  }, [_c('el-col', {
    attrs: {
      "span": 2,
      "offset": 2
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('span', {
    staticClass: "form_color"
  }, [_vm._v("办公地址：")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.officeCountryName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.officeProvinceName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.officeCityName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.officeDistrictName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.officeAddress))])])])], 1), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("供应商资质信息")]), _c('span', {
    staticClass: "second_line"
  }), _vm._v(" "), _c('span', {
    staticClass: "main_word mr4"
  }), _vm._v(" "), (_vm.basicForm.categoryIsBook != 1) ? _c('el-form-item', {
    attrs: {
      "label": "公司注册地址："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.registeredCountryName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.registeredProvinceName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.registeredCityName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.registeredDistrictName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.registeredAddress))])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品类合作类型："
    }
  }, [_c('el-checkbox-group', {
    staticClass: "dib vtb ml_10",
    model: {
      value: (_vm.categoryType),
      callback: function($$v) {
        _vm.categoryType = $$v
      },
      expression: "categoryType"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "1",
      "disabled": ""
    }
  }, [_vm._v("图书类")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "2",
      "disabled": ""
    }
  }, [_vm._v("非图书类")])], 1)], 1), _vm._v(" "), (_vm.basicForm.categoryIsBook == 1) ? _c('el-form-item', {
    staticClass: "dib mt20",
    attrs: {
      "label": "出版社经营许可证电子版："
    }
  }, [_c('div', [_c('img', {
    staticClass: "pic_skan",
    attrs: {
      "src": _vm.basicForm.publicationBusinessLicenseFile
    },
    on: {
      "click": function($event) {
        _vm.previewPic($event)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册登记名称："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.registeredName))])]), _vm._v(" "), (_vm.basicForm.categoryIsBook == 1) ? _c('el-form-item', {
    attrs: {
      "label": "注册登记地址："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.registeredCountryName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.registeredProvinceName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.registeredCityName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.registeredDistrictName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.registeredAddress))])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册资金："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.registeredCapital) + "（单位：万）")]), _vm._v(" "), (_vm.basicForm.registeredCapitalType == 1) ? _c('span', [_vm._v("人民币")]) : _vm._e(), _vm._v(" "), (_vm.basicForm.registeredCapitalType == 2) ? _c('span', [_vm._v("美元")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.basicForm.licenseType != 3),
      expression: "basicForm.licenseType !=3 "
    }],
    attrs: {
      "label": "执照类型："
    }
  }, [(_vm.basicForm.licenseType == 1) ? _c('span', [_vm._v("普通营业执照")]) : _vm._e(), _vm._v(" "), (_vm.basicForm.licenseType == 2) ? _c('span', [_vm._v("三证合一／五证合一")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "营业执照号："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.businessLicenseCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "营业执照电子版："
    }
  }, [_c('div', [(_vm.basicForm.businessLicenseFile) ? _c('img', {
    staticClass: "pic_skan",
    attrs: {
      "src": _vm.basicForm.businessLicenseFile
    },
    on: {
      "click": function($event) {
        _vm.previewPic($event)
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.basicForm.registeredCountry == 1),
      expression: "basicForm.registeredCountry == 1"
    }],
    attrs: {
      "label": "执照有效期："
    }
  }, [(_vm.basicForm.businessLicenseStartDate) ? _c('span', [_vm._v(_vm._s(_vm._f("time")(_vm.basicForm.businessLicenseStartDate)))]) : _vm._e(), _vm._v(" --\n      \t        "), (_vm.basicForm.businessLicenseEndDate) ? _c('span', [_vm._v(_vm._s(_vm._f("time")(_vm.basicForm.businessLicenseEndDate)))]) : _vm._e()]), _vm._v(" "), (_vm.basicForm.licenseType == 1) ? _c('el-form-item', {
    attrs: {
      "label": "组织机构代码："
    }
  }, [(_vm.basicForm.orgCode) ? _c('span', [_vm._v(_vm._s(_vm.basicForm.orgCode))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.basicForm.licenseType == 1) ? _c('el-form-item', {
    attrs: {
      "label": "组织结构代码电子版："
    }
  }, [_c('div', [(_vm.basicForm.orgCodeFile) ? _c('img', {
    staticClass: "pic_skan",
    attrs: {
      "src": _vm.basicForm.orgCodeFile
    },
    on: {
      "click": function($event) {
        _vm.previewPic($event)
      }
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.basicForm.licenseType == 1) ? _c('el-form-item', {
    attrs: {
      "label": "税务登记证电子版："
    }
  }, [_c('div', [(_vm.basicForm.taxFile) ? _c('img', {
    staticClass: "pic_skan",
    attrs: {
      "src": _vm.basicForm.taxFile
    },
    on: {
      "click": function($event) {
        _vm.previewPic($event)
      }
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户许可证电子版："
    }
  }, [_c('div', [(_vm.basicForm.accountOpeningPermitFile) ? _c('img', {
    staticClass: "pic_skan",
    attrs: {
      "src": _vm.basicForm.accountOpeningPermitFile
    },
    on: {
      "click": function($event) {
        _vm.previewPic($event)
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "法定代表人证件类型："
    }
  }, [(_vm.basicForm.personalCardType == 1) ? _c('span', [_vm._v("身份证")]) : _vm._e(), _vm._v(" "), (_vm.basicForm.personalCardType == 2) ? _c('span', [_vm._v("护照")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "法定代表人身份证件电子版："
    }
  }, [_c('div', [(_vm.basicForm.personalCardFile) ? _c('img', {
    staticClass: "pic_skan",
    attrs: {
      "src": _vm.basicForm.personalCardFile
    },
    on: {
      "click": function($event) {
        _vm.previewPic($event)
      }
    }
  }) : _vm._e()])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fe865da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/supplierInfo/basicInfo.vue
// module id = 501
// module chunks = 0